import React, { ReactElement } from "react";
import { useAppSelector } from "redux/hooks";
import { Box, Typography } from "@mui/material";

import { ItalianTerms } from "../ItalianTerms";
import { FrenchTerms } from "../FrenchTerms";
import { ChineseTerms } from "../ChineseTerms";
import styles from "./styles.module.scss"

export default function TermsAndConditions(): ReactElement {
  return (
    <Box className={styles.termsContainer}>
      <Typography className={styles.termsTitle}>REGOLAMENTO SPORT</Typography>
      <br />
      <HtmlElements />
    </Box>
  )
}

function HtmlElements(): ReactElement {
  const locale = useAppSelector(state => state.auth.locale)
  return (
    <div className={styles.terms}>
      {
        locale === "fr" ?
          <FrenchTerms />
          : locale === "zh" ?
            <ChineseTerms />
            :
            <ItalianTerms />
      }
    </div>
  );
}



